(function () {
  var cfg = window.__NLS__ || {};
  var nav = cfg.nav || [];
  var loc = ['en', 'nl', 'de'].indexOf(cfg.locale) > -1 ? cfg.locale : 'en';
  // No fallback. A default here was a trap: with `typesense_host` blank the
  // overlay silently addressed http://localhost:8108, which on an https
  // storefront is blocked as mixed content — so an unset setting surfaced as
  // a browser network error about a machine the shopper does not have,
  // rather than as "you have not configured the host". Missing config is
  // reported as missing config; see MISCONFIGURED below.
  var host = String(cfg.host || '').replace(/\/+$/, '');

  // ── Analytics ──────────────────────────────────────────────────────────
  // Answers the four questions the old search could not: what people search
  // for, where they came from, who they are, and whether they bought.
  //
  // Consent first. This is an EU store, so nothing identifying leaves the
  // browser unless Shopify's Customer Privacy API says analytics processing
  // is allowed. Without consent the query and its result count are STILL
  // reported, with no session id and no customer id — "which queries return
  // nothing" is the report that feeds the synonym set, and it must not have
  // a hole in it the size of everyone who declined the banner.
  //
  // A blank `analytics` setting switches the whole module off.
  var AN = (function () {
    var ENDPOINT = String(cfg.analytics || '').trim();
    var SESSION_TTL = 30 * 60 * 1000;  // a rolling half hour
    var SETTLE_MS = 1200;              // "stopped typing", not "typed"
    var events = [], clicks = [], settle = null, lastSent = '', lastAttr = '';

    function allowed() {
      // An absent API — script blocked, banner not loaded — reads as NO
      // consent. That is the conservative direction for the GDPR question.
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed());
      } catch (e) { return false; }
    }

    // localStorage rather than sessionStorage: the session has to survive
    // the hop to a PDP opened in a new tab, or the order that follows is
    // attributed to nobody.
    function session() {
      if (!allowed()) return null;
      var now = Date.now(), s = null;
      try { s = JSON.parse(localStorage.getItem('nls_session') || 'null'); } catch (e) {}
      if (s && s.id && now - s.ts < SESSION_TTL) {
        s.ts = now;
      } else {
        // First search of a visit. This is the only moment the referrer and
        // the campaign are still readable, so they are captured once here
        // and carried on every event of the session.
        var p = new URLSearchParams(location.search);
        s = {
          id: 'nls-' + now.toString(36) + '-' + Math.random().toString(36).slice(2, 10),
          ts: now,
          referrer: document.referrer || null,
          landingPath: location.pathname || null,
          utmSource: p.get('utm_source'),
          utmMedium: p.get('utm_medium'),
          utmCampaign: p.get('utm_campaign')
        };
      }
      try { localStorage.setItem('nls_session', JSON.stringify(s)); } catch (e) {}
      return s;
    }

    function device() {
      return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches
        ? 'mobile' : 'desktop';
    }

    function flush() {
      if (!ENDPOINT || (!events.length && !clicks.length)) return;
      var payload = { shop: cfg.shop, consent: allowed(), events: events, clicks: clicks };
      events = []; clicks = [];
      try {
        // text/plain keeps this a CORS "simple request". A JSON content-type
        // would trigger a preflight, and sendBeacon cannot answer one — which
        // would drop precisely the batch sent as the page unloads.
        var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
        if (!navigator.sendBeacon || !navigator.sendBeacon(ENDPOINT, blob)) {
          fetch(ENDPOINT, {
            method: 'POST', mode: 'cors', keepalive: true,
            headers: { 'Content-Type': 'text/plain' },
            body: JSON.stringify(payload)
          }).catch(function () {});
        }
      } catch (e) { /* analytics must never be able to break search */ }
    }

    // Attribution. Cart attributes ride the whole checkout and arrive on the
    // order as note_attributes, which is the only channel connecting a click
    // to revenue — the browser never sees the order, and the order never
    // sees the search. Written on click rather than on add-to-cart so the
    // theme's cart code stays untouched: the attributes are harmless on a
    // cart nobody buys, and last-touch is the intended semantic.
    //
    // The underscore prefix keeps them off the order confirmation and the
    // packing slip.
    function cartAttrs(sid, q) {
      var key = sid + '|' + q;
      if (key === lastAttr) return;   // one write per (session, query)
      lastAttr = key;
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _nls_sid: sid, _nls_q: q } })
      }).catch(function () {});
    }

    if (ENDPOINT) {
      // A shopper who searches and then leaves is the most interesting one
      // in the set, so the buffer has to survive the tab going away.
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') { clearTimeout(settle); flush(); }
      });
      window.addEventListener('pagehide', flush);
    }

    return {
      /**
       * Called on every render. Only a query the shopper actually settled on
       * is kept: each keystroke restarts the timer, so "s","sh","shi","shir"
       * collapse into the one "shirt" they were on their way to.
       */
      search: function (q, count, filters) {
        if (!ENDPOINT || !q) return;
        clearTimeout(settle);
        settle = setTimeout(function () {
          // Keyed on the query AND the filters, not the query alone.
          // Applying a facet re-renders with the same query string, so
          // deduping on `q` suppressed every event after the first — which
          // is precisely the event carrying the filter data. The net effect
          // was that `filters` never reached analytics at all, and a query
          // re-run later in a session recorded nothing.
          var sig = q + '\u0000' + (filters && Object.keys(filters).length ? JSON.stringify(filters) : '');
          if (sig === lastSent) return;
          lastSent = sig;
          var s = session();
          events.push({
            sessionId: s && s.id,
            query: q,
            resultCount: count,
            filters: filters && Object.keys(filters).length ? filters : null,
            locale: cfg.locale,
            market: cfg.market,
            device: device(),
            referrer: s && s.referrer,
            landingPath: s && s.landingPath,
            utmSource: s && s.utmSource,
            utmMedium: s && s.utmMedium,
            utmCampaign: s && s.utmCampaign
          });
          flush();
        }, SETTLE_MS);
      },

      /** A click on a result — the bridge from a query to a product to an order. */
      click: function (handle, productId, position) {
        if (!ENDPOINT || !handle) return;
        var q = input.value.trim();
        if (!q) return;
        var s = session();
        clicks.push({
          sessionId: s && s.id, query: q,
          productId: productId || handle, handle: handle, position: position
        });
        if (s) cartAttrs(s.id, q);
        flush();
      }
    };
  })();
  var t = cfg.i18n || {};
  /**
   * Liquid's `t` filter HTML-escapes its output, so "Jersey & knits" arrives
   * as "Jersey &amp; knits". Everything here is then written through esc()
   * before it reaches innerHTML, which escaped it a second time and rendered
   * the entity literally. Decode once at load; esc() re-escapes correctly on
   * the way out, so the strings are still never injected raw.
   */
  var ENTITIES = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", '#39': "'", '#x27': "'" };
  function decodeEntities(s) {
    return String(s).replace(/&(amp|lt|gt|quot|apos|#39|#x27);/g, function (m, e) { return ENTITIES[e]; });
  }
  (function decodeAll(o) {
    for (var k in o) {
      if (typeof o[k] === 'string') o[k] = decodeEntities(o[k]);
      else if (o[k] && typeof o[k] === 'object') decodeAll(o[k]);
    }
  })(t);
  var FAMILIES = t.families || {};
  var COLORS = t.colors || {};
  // Typed: how many matched collections to list. Idle: how many of the
  // main-menu collections to show before "show all".
  var MAX_COLLECTIONS = 6, BROWSE_CAP = 8;
  var PER_PAGE = 24;
  // The fill tier is a rail, not a second result set: one grid row deep on the
  // widest breakpoint, and never paged.
  var RELATED_MAX = 8;
  // Broad/associative synonyms live in their own set so they can be asked for
  // only by the fill tier. Merged with the collection's own set by Typesense.
  var BROAD_SET = 'nolabel-broad';
  var $ = function (s) { return document.querySelector(s); };

  var ov = $('[data-nls-overlay]'), input = $('[data-nls-input]');
  var elClearQ = $('[data-nls-clearq]');
  var elInner = $('.nls-inner');
  var elRail = $('[data-nls-rail]'), elSheetRail = $('[data-nls-sheetrail]');
  var elTitle = $('[data-nls-title]'), elCtrls = $('[data-nls-ctrls]');
  var elChips = $('[data-nls-chips]'), elGrid = $('[data-nls-grid]');
  var elNoRes = $('[data-nls-noresults]'), elFoot = $('[data-nls-foot]');
  var elProg = $('[data-nls-prog]');

  /**
   * A search is two round trips — Typesense for the handles, then Shopify's
   * Section Rendering API for the cards — and they overlap with each other and
   * with the next keystroke's. A counter rather than a boolean, so the bar
   * goes out when the LAST one finishes and not when the first does.
   *
   * Every caller pairs its own busy(true) with exactly one busy(false) via a
   * latch, because a stale request still has to release the count: gating the
   * release on the run token would leak a permanently visible bar.
   */
  var busyCount = 0;
  function busy(on) {
    busyCount = Math.max(0, busyCount + (on ? 1 : -1));
    if (elProg) elProg.classList.toggle('run', busyCount > 0);
  }
  /** One-shot release, so a throw inside a .then cannot double-decrement. */
  function busyLatch() {
    var released = false;
    busy(true);
    return function (v) {
      if (!released) { released = true; busy(false); }
      return v;
    };
  }
  var elColSec = $('[data-nls-colsection]');
  var elRelSec = $('[data-nls-relsection]');
  var sheet = $('[data-nls-sheet]'), elShowResults = $('[data-nls-showresults]');

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); };
  var fold = function (s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[-/_]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase(); };
  function fill(tpl, map) {
    var out = String(tpl == null ? '' : tpl);
    for (var k in map) out = out.split(k).join(map[k]);
    return out;
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /** Localised "N results" — the plural form comes from the locale file. */
  function resultsLabel(n) {
    var tpl = n === 1 ? (t.resultsOne || '1 result') : (t.resultsOther || '2 results');
    return String(tpl).replace(/\d+/, n);
  }

  // `collections` carries the merchandising vocabulary the titles don't: most
  // polos are only identifiable as polos by their collection membership.
  // material_group and material_handles stay here on purpose — that is what
  // keeps the SPECIFIC fabrics findable ("waffle", "piqué", "interlock",
  // "ripstop", "organic cotton") now that only the generalised family is a
  // facet. Verified against the cluster: faceting on a missing field fails the
  // search, but query_by on material_handles (a string[]) is fine.
  var TITLES = ['title_' + loc].concat(['title_en', 'title_nl', 'title_de'].filter(function (f) { return f !== 'title_' + loc; }));
  // color / color_group are the reason "black" used to return a beige chino:
  // neither was in query_by, so a colour query only ever matched by accident,
  // through a collection name. color is the merchandising name ("Deep Dive
  // Blue"), color_group the nine-value PLP facet ("Blue") — the first makes
  // the specific shade findable, the second makes the family findable, and
  // the colour synonyms map NL/DE onto the group.
  var EXTRA = ['collections', 'color', 'color_group', 'material_group', 'material_handles', 'product_type', 'tags', 'title_raw', 'vendor', 'skus'];
  var QUERY_BY = TITLES.concat(EXTRA).join(',');
  var WEIGHTS = TITLES.map(function (_, i) { return i === 0 ? 8 : 5; }).concat([4, 5, 5, 4, 4, 4, 3, 2, 2, 1]).join(',');
  var T = function (d) { return d['title_' + loc] || d.title_en || ''; };
  var N = function (d) { return d['name_' + loc] || d.name_en || ''; };

  // collection id -> { handle, title, product_count, is_material }. Fabric
  // labels are no longer cached: they were only ever needed to name the chips
  // in the old MATERIAL band, and the per-query materials search already
  // returns the names the "did you mean" rail shows.
  var COLS = {};

  // ── Facets ─────────────────────────────────────────────────────────────
  // One rail, ordered by how much a shopper actually narrows by. Material is
  // the generalised `material_family`; the 40 fabric stories it replaces are
  // still searchable, just not chips. Availability is deliberately absent:
  // out-of-stock products are shown greyed with a notify-me rather than hidden.
  var G = t.groups || {};
  // Every list in the rail is capped with a "show all", so the whole column
  // is scannable in one screen rather than being a page of links with the
  // products pushed below the fold. Nothing is hidden — only folded.
  var GROUPS = [
    { field: 'product_type',    label: G.product_type || 'Category', cap: 6 },
    { field: 'material_family', label: G.material_family || 'Material', cap: 6,
      names: function (v) { return FAMILIES[v] || v; } },
    { field: 'color_group',     label: G.color_group || 'Colour', swatch: true, cap: 8,
      names: function (v) { return COLORS[fold(v)] || v; } },
    { field: 'sizes_in_stock',  label: G.sizes_in_stock || 'Size', sizes: true, cap: 8 },
    // Pills, not rows: "20%" / "30%" set as plain text read as a caption
    // rather than something you can press. The border is what makes them
    // legible as controls.
    { field: 'discount_bucket', label: G.discount_bucket || 'Sale', pills: true,
      names: function (v) { return v === '40-plus' ? (t.discount40Plus || '40% or more') : v + '%'; } }
  ];
  // The PLP renders colour as swatches; facets only carry the group name, so
  // these are the nine nolabel.color_group values mapped to a representative hex.
  var COLOR_HEX = { blue: '#3B5A8C', green: '#4A6B4A', brown: '#7A5540', beige: '#D8CDB8',
    white: '#FFFFFF', grey: '#8C8C8C', pink: '#D9A0A8', black: '#1A1A1A', red: '#B03A32' };

  // ── State ──────────────────────────────────────────────────────────────
  var ACTIVE = {};            // field -> array of selected values
  var SORTS = [
    { id: 'relevance', label: (t.sorts || {}).relevance || 'Relevance', by: null },
    { id: 'new',       label: (t.sorts || {}).new || 'New in',          by: 'published_at:desc' },
    { id: 'price_asc', label: (t.sorts || {}).price_asc || 'Price: low to high', by: 'price:asc' },
    { id: 'price_desc',label: (t.sorts || {}).price_desc || 'Price: high to low', by: 'price:desc' }
  ];
  var sortId = 'relevance';
  // The field 'Relevance' actually orders by. rank_score is sales *and* a
  // decaying credit for being new; the probe in withLookups drops it back to
  // sales_rank on an index that predates the field. See NEWNESS_BOOST in
  // nolabel-app/app/lib/search/build-doc.server.ts.
  var RANK_FIELD = 'rank_score';
  var page = 1;               // load-more cursor
  var shown = [];             // handles currently in the grid, in order
  var found = 0;
  var expanded = {};          // field -> true once "show all" was clicked

  function activeCount() { var n = 0; for (var k in ACTIVE) n += (ACTIVE[k] || []).length; return n; }
  function isOn(field, v) { return (ACTIVE[field] || []).indexOf(v) !== -1; }
  function toggle(field, v) {
    var a = ACTIVE[field] || (ACTIVE[field] = []);
    var i = a.indexOf(v);
    if (i === -1) a.push(v); else a.splice(i, 1);
    if (!a.length) delete ACTIVE[field];
  }
  /** Any change to query, filters or sort restarts pagination. */
  function reset() { page = 1; shown = []; }

  // ── Query building ─────────────────────────────────────────────────────
  // Typesense filter_by. `except` is omitted so a group's own facet counts stay
  // disjunctive — otherwise picking Blue would make every other colour vanish.
  // Sold out is not purchasable, so it is excluded from the grid AND from
  // every facet count. Applied here rather than per-query so the two can
  // never disagree: a facet that counted sold-out stock would promise
  // results the grid then refuses to show.
  var BASE_CLAUSE = 'available:=true';
  function filterClause(except) {
    var parts = [BASE_CLAUSE];
    for (var f in ACTIVE) {
      if (f === except || !ACTIVE[f].length) continue;
      parts.push(f + ':=[' + ACTIVE[f].map(function (v) { return '`' + v + '`'; }).join(',') + ']');
    }
    return parts.join(' && ');
  }

  function body(q) {
    var hasText = !!(q && q.trim());
    var query = hasText ? q.trim() : '*';
    var grouped = !hasText && !activeCount() && page === 1;   // bestsellers idle only
    // Typo correction normally only runs when a query returns almost nothing,
    // which is why a half-typed word felt "not fuzzy yet".
    //
    // Every products search — results AND facets — must use these. The facet
    // queries used to fall back to Typesense's defaults, so they matched a
    // different set: "red linen shirt" put 4 products in the grid while every
    // filter counted over 1.
    // Two matchers, because "what the shopper asked for" and "what we show to
    // fill the page" are different questions and were being answered by one
    // query. MATCH drives the grid AND every facet count; LOOSE drives the
    // Related tier below the divider and nothing else.
    //
    // demote_synonym_match ranks a literal match above a synonym-expanded one,
    // so a product whose title actually says the word leads its own query.
    //
    // synonym_sets is MERGED with the collection's own set rather than
    // replacing it, so LOOSE searches nolabel + nolabel-broad while MATCH
    // searches nolabel alone. nolabel holds translations and true synonyms;
    // nolabel-broad holds the family expansions (interlock -> jersey, navy ->
    // every blue) that are useful as suggestions and wrong as results.
    //
    // drop_tokens_mode matters more than it looks. When a multi-word query
    // finds nothing, Typesense drops tokens and retries — right to left by
    // default, so the LAST word goes first and the first word is the one that
    // survives. "long sleeve" therefore searched "long", hit the campaign
    // collection "For warm days and long evenings", returned 20 shorts and a
    // bag, and never tried "sleeve" at all. both_sides retries from either
    // end, so the word that actually carries the query gets its turn.
    var MATCH = { prefix: true, num_typos: 2, typo_tokens_threshold: 3,
                  drop_tokens_threshold: 2, drop_tokens_mode: 'both_sides:3',
                  demote_synonym_match: true };
    var LOOSE = { prefix: true, num_typos: 2, typo_tokens_threshold: 3,
                  drop_tokens_threshold: 2, drop_tokens_mode: 'both_sides:3',
                  synonym_sets: BROAD_SET };
    function productSearch(extra, matcher) {
      var q2 = { collection: 'products', q: query, query_by: QUERY_BY };
      var m = matcher || MATCH;
      for (var k in m) q2[k] = m[k];
      for (var k2 in extra) q2[k2] = extra[k2];
      return q2;
    }
    var chosen = SORTS.filter(function (s) { return s.id === sortId; })[0] || SORTS[0];
    // Within a result page _text_match is almost always flat — every one of
    // the top 30 hits for "shirt" scores identically — so this tie-break IS
    // the ordering, not a tie-break. On trailing sales alone that buried the
    // entire latest drop: 77 of 312 products, none in the top 50.
    var sort_by = chosen.by ||
      (hasText ? '_text_match:desc,' + RANK_FIELD + ':desc' : RANK_FIELD + ':desc');
    var main = productSearch({
      query_by_weights: WEIGHTS,
      sort_by: sort_by,
      per_page: grouped ? 16 : PER_PAGE,
      page: grouped ? 1 : page
    });
    var clause = filterClause();
    if (clause) main.filter_by = clause;
    if (grouped) { main.group_by = 'style_group'; main.group_limit = 3; }

    var navIds = nav.map(function (n) { return n.id; });
    var col;
    if (!hasText && navIds.length) {
      col = { collection: 'collections', q: '*', query_by: 'title_' + loc,
              filter_by: 'id:=[' + navIds.join(',') + ']', per_page: navIds.length };
    } else if (!hasText) {
      // No nav menu to draw on. Ranking by _text_match against q=`*` is
      // meaningless, and it filled the browse list with per-style buckets
      // ("Yamane JE30135", "JE01002-BRW"); biggest-first at least lands on
      // real categories.
      col = { collection: 'collections', q: '*', query_by: 'title_' + loc,
              filter_by: 'is_material:=false && product_count:>8', sort_by: 'product_count:desc', per_page: 8 };
    } else {
      col = { collection: 'collections', q: query, query_by: 'title_' + loc, sort_by: '_text_match:desc',
              filter_by: 'is_material:=false', per_page: 8 };
    }

    // The SPECIFIC fabric stories. Not a facet any more — they surface only
    // when the query names one ("seersucker", "herringbone"), which is exactly
    // the "unless someone searches for it" case the family axis is built for.
    var mats = { collection: 'materials', q: query, query_by: 'name_' + loc, per_page: 12 };
    if (!hasText) mats.sort_by = 'product_count:desc';

    // Facet counts must stay disjunctive: a group with an active selection gets
    // its own query with that group's filter removed, so its other values keep
    // real counts. All of it rides in the same multi_search — one round trip.
    var searches = [main, col, mats], facetIndex = {}, looseIndex = null;
    // Only worth asking when there is a term to broaden. Deliberately ordered
    // by relevance rather than by the shopper's chosen sort: this is a
    // suggestion rail, not a second result set they are paging through.
    if (hasText) {
      looseIndex = searches.length;
      searches.push(productSearch({
        filter_by: clause || undefined,
        sort_by: '_text_match:desc,sales_rank:desc',
        per_page: RELATED_MAX,
        page: 1
      }, LOOSE));
    }
    var idle = GROUPS.filter(function (g) { return !ACTIVE[g.field]; });
    if (idle.length) {
      var base = searches.length;
      searches.push(productSearch({ filter_by: clause || undefined,
        facet_by: idle.map(function (g) { return g.field; }).join(','), per_page: 0, max_facet_values: 100 }));
      idle.forEach(function (g) { facetIndex[g.field] = base; });
    }
    GROUPS.filter(function (g) { return ACTIVE[g.field]; }).forEach(function (g) {
      var without = filterClause(g.field);
      facetIndex[g.field] = searches.length;
      searches.push(productSearch({ filter_by: without || undefined,
        facet_by: g.field, per_page: 0, max_facet_values: 100 }));
    });
    return { searches: searches, facetIndex: facetIndex, looseIndex: looseIndex };
  }

  // ── Facet value quality ────────────────────────────────────────────────
  // Facet values are raw merchandising data and are not uniformly filled in,
  // so a group states what a usable value looks like and everything else is
  // kept out of the rail. Two real cases in the catalogue: the size option
  // holds gift-card denominations ("€75"), and product-name values still hold
  // bare Shopify ids for products that never got a name.
  var SIZE_ORDER = ['XXS','XS','S','M','L','XL','XXL','XXXL'];
  function looksLikeSize(v) {
    var s = String(v || '').trim();
    if (SIZE_ORDER.indexOf(s.toUpperCase()) !== -1) return true;
    if (/^\d{1,3}([-/]\d{1,3})?$/.test(s)) return true;   // 43 (shoe), 31-32 / 32/32 (waist-length)
    return /^one size$/i.test(s);
  }
  var QUALITY = { sizes_in_stock: looksLikeSize };
  function applyQuality(field, counts) {
    var ok = QUALITY[field];
    return ok ? counts.filter(function (c) { return ok(c.value); }) : counts;
  }

  // Sizes are three scales sharing one facet: letter sizes, waist-length pairs
  // and plain numbers (shoes, belts). The design asks for them split rather
  // than interleaved, so rank each tier separately and label the groups.
  function sizeTier(v) {
    var s = String(v).trim().toUpperCase();
    if (SIZE_ORDER.indexOf(s) !== -1) return 0;
    if (/^\d{1,3}[-/]\d{1,3}$/.test(s)) return 1;
    if (/^\d{1,3}$/.test(s)) return 2;
    return 3;
  }
  function sizeRank(v) {
    var s = String(v).trim().toUpperCase();
    var a = SIZE_ORDER.indexOf(s);
    if (a !== -1) return [0, a, 0];
    var pair = s.match(/^(\d{1,3})[-/](\d{1,3})$/);
    if (pair) return [1, +pair[1], +pair[2]];
    if (/^\d{1,3}$/.test(s)) return [2, +s, 0];
    return [3, 0, 0];
  }
  function sortValues(field, counts) {
    if (field !== 'sizes_in_stock') return counts;
    return counts.slice().sort(function (a, b) {
      var ra = sizeRank(a.value), rb = sizeRank(b.value);
      return ra[0] - rb[0] || ra[1] - rb[1] || ra[2] - rb[2] || String(a.value).localeCompare(String(b.value));
    });
  }
  function facetCounts(results, facetIndex, field) {
    var r = results[facetIndex[field]];
    if (!r) return [];
    var f = (r.facet_counts || []).filter(function (x) { return x.field_name === field; })[0];
    return (f && f.counts) || [];
  }
  function labelFor(g, v) { return g.names ? g.names(v) : v; }

  // ── Rail rendering ─────────────────────────────────────────────────────
  var TICK = '<svg class="nls-tick" width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M2 7.5l3.5 3.5L12 4"/></svg>';
  var CHEV = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M3.5 1.5L7 5l-3.5 3.5"/></svg>';

  function facetBlock(title, inner) {
    if (!inner) return '';
    return '<div class="nls-facet"><span class="nls-lbl">' + esc(title) + '</span>' + inner + '</div>';
  }
  function row(g, c) {
    var label = labelFor(g, c.value);
    var sw = g.swatch
      ? '<span class="nls-sw" style="background:' + (COLOR_HEX[fold(c.value)] || '#DDD') + '"></span>' : '';
    return '<button type="button" class="nls-row' + (isOn(g.field, c.value) ? ' on' : '') + '"' +
      ' aria-pressed="' + (isOn(g.field, c.value) ? 'true' : 'false') + '"' +
      ' data-f="' + esc(g.field) + '" data-v="' + esc(c.value) + '">' + sw +
      '<span class="lbl">' + esc(label) + '</span>' +
      '<span class="nls-num">' + c.count + '</span>' + TICK + '</button>';
  }
  /**
   * A bordered, tappable value. `countInTitle` is for sizes, where 19 pills
   * each carrying a number would drown the size itself; everywhere else the
   * count sits inside the box next to the label.
   */
  function pill(g, c, countInTitle) {
    var on = isOn(g.field, c.value);
    return '<button type="button" class="nls-pill' + (on ? ' on' : '') + '"' +
      ' aria-pressed="' + (on ? 'true' : 'false') + '"' +
      (countInTitle ? ' title="' + esc(c.count) + '"' : '') +
      ' data-f="' + esc(g.field) + '" data-v="' + esc(c.value) + '">' +
      esc(labelFor(g, c.value)) +
      (countInTitle ? '' : '<span class="n">' + c.count + '</span>') + '</button>';
  }
  function pillBlock(g, counts) {
    return '<div class="nls-pills">' + counts.map(function (c) { return pill(g, c); }).join('') + '</div>';
  }

  function sizeBlock(g, counts) {
    // Letter sizes, then W×L, then plain numbers — each its own labelled run,
    // instead of one 19-cell grid that reads "31-32" as 31 and interleaves it
    // with the shoe sizes.
    var TIER_LABEL = ['S – XXL', 'W × L', '—', ''];
    var tiers = [[], [], [], []];
    counts.forEach(function (c) { tiers[sizeTier(c.value)].push(c); });
    var out = '', total = counts.length, budget = expanded[g.field] ? Infinity : (g.cap || 8);
    tiers.forEach(function (list, i) {
      if (!list.length) return;
      var take = budget === Infinity ? list : list.slice(0, Math.max(0, budget));
      if (!take.length) return;
      budget -= take.length;
      // Only label a run when more than one scale is actually present.
      var labelled = tiers.filter(function (l) { return l.length; }).length > 1;
      out += (labelled && TIER_LABEL[i] ? '<div class="nls-lbl nls-scale">' + esc(TIER_LABEL[i]) + '</div>' : '') +
        '<div class="nls-pills">' + take.map(function (c) {
          return pill(g, c, true);
        }).join('') + '</div>';
    });
    if (!out) return '';
    if (!expanded[g.field] && total > (g.cap || 8)) {
      out += '<button type="button" class="nls-more" data-nls-expand="' + esc(g.field) + '">' +
        esc(fill(t.showAll || 'Show all __N__', { '__N__': total })) + '</button>';
    }
    return out;
  }

  /** "Show all N", sharing the expand state that the facet groups use. */
  function showAllButton(key, total) {
    return '<button type="button" class="nls-more" data-nls-expand="' + esc(key) + '">' +
      esc(fill(t.showAll || 'Show all __N__', { '__N__': total })) + '</button>';
  }

  /** Collections navigate; every facet below filters. */
  function collectionsBlock(rows, label, cap) {
    if (!rows.length) return '';
    var total = rows.length;
    var show = (cap && !expanded.collections) ? rows.slice(0, cap) : rows;
    var inner = show.map(function (r) {
      // `root` carries the locale prefix. A bare /collections/… link sent
      // every /nl/ and /de/ shopper back to the English storefront.
      return '<a class="nls-row nls-navrow" href="' + root + 'collections/' + esc(r.handle) + '">' +
        '<span class="lbl">' + esc(r.title) + '</span>' +
        '<span class="nls-num">' + r.count + '</span>' + CHEV + '</a>';
    }).join('');
    if (total > show.length) inner += showAllButton('collections', total);
    return facetBlock(label, inner);
  }
  /**
   * Search help, not a facet. Rendered as wrapped underlined terms rather
   * than counted rows — as rows they read as categories to browse into, when
   * what they actually do is re-run the search with a different query.
   */
  function termsBlock(label, terms) {
    if (!terms.length) return '';
    return facetBlock(label, '<div class="nls-help">' + terms.map(function (term) {
      return '<button type="button" class="nls-helpterm" data-term="' + esc(term) + '">' +
        esc(term) + '</button>';
    }).join('') + '</div>');
  }
  /**
   * Popular searches come from the locale files, not from analytics: the
   * Typesense analytics collection is not in the search key's scope yet, and
   * the previous stand-in listed the biggest fabric-story names, which is the
   * long-tail vocabulary this rework exists to stop showing. A merchandiser
   * can edit these per locale; they were seeded from 30 days of real queries.
   */
  function popularTerms() {
    return String(t.popularTerms || '').split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  /** One facet, or '' when the query leaves it with nothing to offer. */
  function facetGroupHtml(g, results, facetIndex) {
    var counts = sortValues(g.field, applyQuality(g.field, facetCounts(results, facetIndex, g.field)));
    // Keep a selected value visible even if this query gives it a zero count.
    (ACTIVE[g.field] || []).forEach(function (v) {
      if (!counts.some(function (c) { return c.value === v; })) counts.unshift({ value: v, count: 0 });
    });
    // Empty facet rows are hidden. Nothing renders a heading with no options.
    if (!counts.length) return '';
    if (g.sizes) return facetBlock(g.label, sizeBlock(g, counts));
    if (g.pills) return facetBlock(g.label, pillBlock(g, counts));
    var cap = expanded[g.field] ? counts.length : (g.cap || counts.length);
    var inner = counts.slice(0, cap).map(function (c) { return row(g, c); }).join('');
    if (counts.length > cap) inner += showAllButton(g.field, counts.length);
    return facetBlock(g.label, inner);
  }
  function groupByField(field) {
    return GROUPS.filter(function (g) { return g.field === field; })[0];
  }

  /**
   * `facetsOnly` builds the mobile sheet's copy. The sheet is labelled Filter
   * and its footer says "show N results", so the collection links and the
   * did-you-mean terms are left out of it — both navigate or re-query, which
   * is not what a filter sheet promises.
   */
  function buildRail(results, facetIndex, colRows, matTerms, hasText, isEmpty, facetsOnly) {
    var html = '';
    if (facetsOnly) {
      GROUPS.forEach(function (g) { html += facetGroupHtml(g, results, facetIndex); });
      return html;
    }
    if (isEmpty) {
      // A dead query is exactly when help matters most, so this rail leads
      // with the two things that can rescue it — near-miss terms, then the
      // searches that work for everyone else — before offering collections.
      html += termsBlock(t.didYouMean || 'Did you mean', matTerms.slice(0, 5));
      html += termsBlock(t.popularSearches || 'Popular searches', popularTerms());
      html += collectionsBlock(colRows, t.collections || 'Collections', 5);
      return html;
    }
    if (!hasText && !activeCount()) {
      // Zero-query: the full browse list, then browse by material.
      //
      // The material slot used to hold "Popular searches", filled with the
      // biggest fabric-story names because there is no analytics source wired
      // up yet. That listed "Organic Cotton Jersey", "Portuguese Cotton" and
      // "Combed Cotton" as the things to search for — the exact long-tail
      // vocabulary this rework exists to stop showing. The material families
      // are real, localised, counted, and clicking one filters instead of
      // re-running a text query. Swap this back to genuine popular searches
      // once the Typesense analytics collection is in the key's scope.
      html += collectionsBlock(colRows, t.browse || 'Browse', BROWSE_CAP);
      var mat = groupByField('material_family');
      if (mat) html += facetGroupHtml(mat, results, facetIndex);
      return html;
    }
    // Search help first: it answers "did I type the right thing", which comes
    // before any decision about how to narrow the results.
    if (hasText) html += termsBlock(t.didYouMean || 'Did you mean', matTerms.slice(0, 5));
    html += collectionsBlock(colRows, t.collections || 'Collections', MAX_COLLECTIONS);
    GROUPS.forEach(function (g) { html += facetGroupHtml(g, results, facetIndex); });
    return html;
  }

  function renderChips() {
    var chips = [];
    GROUPS.forEach(function (g) {
      (ACTIVE[g.field] || []).forEach(function (v) {
        chips.push('<button type="button" class="nls-chip" data-f="' + esc(g.field) + '" data-v="' + esc(v) + '">' +
          esc(labelFor(g, v)) + ' ✕</button>');
      });
    });
    elChips.innerHTML = chips.length
      ? chips.join('') + '<button type="button" class="nls-chipclear" data-nls-clear>' + esc(t.clearAll || 'Clear all') + '</button>'
      : '';
  }

  /** Narrow enough that the rail is hidden and the bottom sheet takes over. */
  function isNarrow() {
    return window.matchMedia && window.matchMedia('(max-width:1023px)').matches;
  }
  function renderControls(hasText, isEmpty) {
    var parts = [];
    // No filter button on the no-results screen: the sheet behind it would be
    // empty, and "show 0 results" is not an action.
    if ((activeCount() || hasText) && !isEmpty) {
      parts.push('<button type="button" class="nls-ghost nls-mobfilter" data-nls-sheetopen>' +
        '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M0 2h12M2 6h8M4 10h4"/></svg>' +
        esc(t.filter || 'Filter') + (activeCount() ? ' · ' + activeCount() : '') + '</button>');
    }
    if (!isEmpty) {
      var cur = SORTS.filter(function (s) { return s.id === sortId; })[0] || SORTS[0];
      // "Sort: Price: low to high" does not fit a 390px bar next to the filter
      // button, so the narrow layout shows the bare label.
      var sortLabel = isNarrow() ? (t.sort || 'Sort') : fill(t.sortBy || 'Sort: __O__', { '__O__': cur.label });
      parts.push('<button type="button" class="nls-ghost" data-nls-sorttrig aria-expanded="false">' +
        esc(sortLabel) +
        '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M2 4l3 3 3-3"/></svg></button>' +
        '<div class="nls-sortpop" data-nls-sortpop>' + SORTS.map(function (s) {
          return '<button type="button" class="nls-sortopt' + (s.id === sortId ? ' on' : '') + '" data-sort="' + esc(s.id) + '">' + esc(s.label) + '</button>';
        }).join('') + '</div>');
    }
    elCtrls.innerHTML = parts.join('');
  }

  // ── Cards ──────────────────────────────────────────────────────────────
  // Cards are the real `component.product-item`, rendered by Liquid via
  // sections/search-products, cached by handle and assembled here in
  // Typesense relevance order. That is what gives search the same sale badge,
  // wishlist button, colour swatches and price formatting as the PLP.
  var cardCache = {};
  var CARD_CACHE_MAX = 240;
  function trimCache() {
    var keys = Object.keys(cardCache);
    if (keys.length <= CARD_CACHE_MAX) return;
    keys.slice(0, keys.length - CARD_CACHE_MAX).forEach(function (k) { delete cardCache[k]; });
  }
  var inflight = {};
  var runToken = 0;
  var FIRST_BATCH = 12;

  /** Resolves true when every requested card is cached, false on failure. */
  function fetchCards(handles) {
    var missing = handles.filter(function (h) { return !cardCache[h]; });
    if (!missing.length) return Promise.resolve(true);
    var waits = [], fresh = [];
    missing.forEach(function (h) {
      if (inflight[h]) waits.push(inflight[h]);
      else fresh.push(h);
    });
    if (fresh.length) {
      var req = fetch(root + 'search?section_id=search-products&q=' + fresh.map(encodeURIComponent).join(','))
        .then(function (r) {
          if (!r.ok) throw new Error('section render ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-product-item]').forEach(function (el) {
            cardCache[el.dataset.productHandle] = el.outerHTML;
          });
          trimCache();
          return true;
        })
        .catch(function (err) {
          // A failed card render is not "no results". Reporting it as one over
          // a search that genuinely matched sent shoppers away — and Shopify's
          // Section Rendering API is rate limited, so this is the most likely
          // way the overlay breaks under real traffic.
          console.error('[search] card fetch failed:', err);
          return false;
        })
        .then(function (ok) {
          fresh.forEach(function (h) { delete inflight[h]; });
          return ok;
        });
      fresh.forEach(function (h) { inflight[h] = req; });
      waits.push(req);
    }
    return Promise.all(waits).then(function (rs) { return rs.every(Boolean); });
  }

  function skeletons(n) {
    return new Array(Math.max(n, 0)).fill('<div class="nls-skel"></div>').join('');
  }

  /**
   * Reconcile the grid in place: reuse the DOM node a handle already has and
   * move it, rather than rebuilding innerHTML. Re-inserting an <img> makes the
   * browser re-decode (and often re-request) the image, so the old
   * "blank to skeletons, then repaint everything" path meant every filter
   * click visibly reloaded all the imagery even when the cards were cached.
   *
   * With `holes`, a handle whose card has not arrived yet gets a skeleton in
   * its slot instead of being skipped (see renderCards).
   */
  function paint(el, handles, holes) {
    var have = {};
    el.querySelectorAll('[data-product-item]').forEach(function (n) { have[n.dataset.productHandle] = n; });
    var frag = document.createDocumentFragment(), added = 0;
    handles.forEach(function (h) {
      var node = have[h];
      if (node) { delete have[h]; frag.appendChild(node); return; }  // moves, no reload
      var html = cardCache[h];
      if (!html) {
        if (holes) {
          var skel = document.createElement('div');
          skel.className = 'nls-skel';
          frag.appendChild(skel);
        }
        return;
      }
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var freshNode = tmp.firstElementChild;
      if (freshNode) { frag.appendChild(freshNode); added++; }
    });
    while (el.firstChild) el.removeChild(el.firstChild);
    el.appendChild(frag);
    // Only when something new arrived — remounting untouched cards is wasted
    // work and re-runs the wishlist/swatch wiring for no reason.
    if (added && window.app) window.app.mount();
    return added;
  }

  /** Fill `el` with cards for `handles`, in order, first batch first. */
  function renderCards(el, handles, empty) {
    if (!handles.length) { el.innerHTML = empty ? '<div class="nls-empty">' + empty + '</div>' : ''; return Promise.resolve(); }
    var token = runToken;
    // The first batch has to cover everything already on screen, not just
    // FIRST_BATCH: paint() rebuilds the container from the list it is given,
    // so a load-more that painted only the first 12 would drop rows 13–24 out
    // of the grid and put them back a moment later.
    var onScreen = el.querySelectorAll('[data-product-item]').length;
    var headSize = Math.max(FIRST_BATCH, onScreen);
    var head = handles.slice(0, headSize), tail = handles.slice(headSize);
    // run() may already have laid skeletons down for the Typesense trip.
    // Re-writing innerHTML would tear them out and restart the pulse, so the
    // placeholder visibly stutters halfway through a single search.
    if (!onScreen && !el.querySelector('.nls-skel')) {
      el.innerHTML = skeletons(Math.min(handles.length, FIRST_BATCH));
    }
    var cached = head.every(function (h) { return cardCache[h]; });
    if (cached) paint(el, head);
    // Cards from the previous query must not stay up while this one's cards
    // load: the heading already names the new query, and for 0.5-1s the grid
    // showed jeans under "16 results for overshirt". Keep the cards that are
    // in the new list (moved, not reloaded) and hold a skeleton in every
    // other slot until its card arrives.
    else if (onScreen) paint(el, head, true);
    // Cards are the second half of the same wait: the bar stays up until the
    // visible batch is painted, not just until Typesense answers. The tail
    // batch loads behind the fold and is deliberately not counted.
    var release = busyLatch();
    return fetchCards(head).then(release).then(function (ok) {
      if (token !== runToken) return;
      if (!ok && !el.querySelector('[data-product-item]')) {
        el.innerHTML = unavailableHtml(t.unavailable || 'Search is temporarily unavailable.', 'nls-empty');
        return;
      }
      if (!cached && !paint(el, head) && !el.firstChild && empty) {
        el.innerHTML = '<div class="nls-empty">' + empty + '</div>';
      }
      if (!tail.length) return;
      return fetchCards(tail).then(function (tailOk) {
        if (token !== runToken || !tailOk) return;
        paint(el, handles);
      });
    });
  }

  // ── No results ─────────────────────────────────────────────────────────
  /**
   * A route, not a message. Names the query, points at the nearest real
   * collection with a count, and shows that collection's best sellers. No
   * empty facet headings and no engine timings.
   */
  function renderNoResults(q, nearest) {
    var cta = nearest
      ? '<a class="nls-btn" href="' + root + 'collections/' + esc(nearest.handle) + '">' +
          esc(nearest.title) + ' · ' + nearest.product_count + '</a>'
      : '';
    // With filters but no query there is no term to quote, so the heading
    // becomes the plain count rather than: No results for “”.
    var heading = q
      ? fill(t.noResultsTitle || 'No results for “__Q__”', { '__Q__': q })
      : resultsLabel(0);
    // Without a nearest collection this used to stop at the message: a dead
    // end, on the one screen where the shopper has already told us they
    // found nothing. Fall back to the catalogue's best sellers so there is
    // always something to tap. RANK_FIELD rather than sales_rank because it
    // blends newness in, which is what makes this "best sellers or new in"
    // rather than a list of last season's hits.
    var label = nearest ? moreFromLabel(nearest.title) : (t.bestsellers || 'Bestsellers');
    var body = nearest
      ? (t.noResultsBody || '')
      : (t.noResultsBodyGeneric || t.noResultsBody || '');
    elNoRes.innerHTML = '<div class="nls-nores">' +
      '<h3>' + esc(heading) + '</h3>' +
      '<p>' + esc(body) + '</p>' + cta + '</div>' +
      '<div class="nls-divider" style="margin-top:32px"><span class="nls-lbl">' +
        esc(label) +
      '</span></div><div class="nls-grid" data-nls-nogrid style="margin-top:14px"></div>';
    var token = runToken;
    tsFetch({ method: 'POST', body: JSON.stringify({ searches: [
      { collection: 'products', q: '*', query_by: 'title_' + loc,
        filter_by: nearest ? 'collection_ids:=' + nearest.id + ' && ' + BASE_CLAUSE : BASE_CLAUSE,
        sort_by: (nearest ? 'sales_rank' : RANK_FIELD) + ':desc', per_page: 8 }] }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (token !== runToken) return;
        var el = elNoRes.querySelector('[data-nls-nogrid]');
        if (!el) return;
        renderCards(el, ((d.results[0] || {}).hits || []).map(function (h) { return h.document.handle; }), '');
      })
      .catch(function (err) { console.error('[search] no-results grid failed:', err); });
  }

  /**
   * The biggest collection in the catalogue, as the fallback destination when a
   * query matched nothing at all and there is no result set to score against.
   */
  /**
   * `search.more_from` carries a `collection` placeholder that Liquid leaves
   * alone when no param is passed, so it is substituted here at runtime.
   *
   * NB the pattern is written with escaped braces and the fallback carries no
   * placeholder at all: this whole file is a Liquid template, so a literal
   * pair of adjacent braces in here would be evaluated at render time — on a
   * collection page it would interpolate the actual collection object.
   */
  var MORE_FROM_TOKEN = /\{\{\s*collection\s*\}\}/;
  function moreFromLabel(title) {
    var tpl = t.moreFrom;
    if (!tpl) return '“' + title + '”';
    return String(tpl).replace(MORE_FROM_TOKEN, title);
  }

  /** COLS is keyed by id; the rail rows carry handles. */
  function colIdByHandle(handle) {
    for (var id in COLS) if (COLS[id].handle === handle) return id;
    return null;
  }

  /**
   * "More from …": the collection that the matched products actually cluster
   * in, scored by share rather than raw overlap so a genuine category
   * ("Shirts") beats a catch-all ("All Clothing").
   */
  function relatedCollection(hits) {
    var tally = {};
    hits.slice(0, 30).forEach(function (h) {
      (h.document.collection_ids || []).forEach(function (id) { tally[id] = (tally[id] || 0) + 1; });
    });
    var best = null, bestScore = 0;
    for (var id in tally) {
      var c = COLS[id];
      // Fabric collections duplicate the Material facet; tiny ones are internal
      // per-style buckets and make a poor "more from" row.
      if (!c || c.is_material || c.product_count < 8 || tally[id] < 2) continue;
      var score = tally[id] / Math.sqrt(c.product_count);
      if (score > bestScore) { bestScore = score; best = c; }
    }
    return best;
  }

  // Decision #2: matched collection → its products inline, under a divider.
  // Memoised on the collection id: toggling a filter usually leaves the related
  // collection unchanged, and refetching that whole second grid on every click
  // was a second, invisible source of image churn.
  var lastColId = null;
  function appendCollection(col) {
    if (!col) { lastColId = null; elColSec.innerHTML = ''; return; }
    if (col.id === lastColId && elColSec.querySelector('[data-product-item]')) return;
    lastColId = col.id;
    var token = runToken;
    var mine = shown.slice();
    tsFetch({ method: 'POST', body: JSON.stringify({ searches: [
      { collection: 'products', q: '*', query_by: 'title_' + loc, filter_by: 'collection_ids:=' + col.id,
        sort_by: 'sales_rank:desc', per_page: 24 }] }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        if (token !== runToken) return;
        var handles = ((d.results[0] || {}).hits || [])
          .map(function (h) { return h.document.handle; })
          .filter(function (h) { return mine.indexOf(h) === -1; });
        if (!handles.length) { elColSec.innerHTML = ''; return; }
        var heading = moreFromLabel(col.title);
        elColSec.innerHTML = '<div class="nls-divider"><span class="nls-lbl">' + esc(heading) + ' (' + handles.length + ')</span></div>' +
          '<div class="nls-grid" data-nls-colgrid style="margin-top:14px"></div>';
        renderCards(elColSec.querySelector('[data-nls-colgrid]'), handles, '');
      }).catch(function (err) { console.error('[search] related collection failed:', err); });
  }

  /**
   * The fill tier: everything the broad synonym set reaches that the query
   * itself did not. Rendered under its own divider so it can never be
   * mistaken for a result — a shopper searching "interlock" sees the
   * interlock products as results and the rest of the jersey family here.
   *
   * Silent by design when the broad set is missing from the cluster: the leg
   * comes back as a per-search error inside an otherwise fine multi_search,
   * so the tier simply does not render and the grid is unaffected.
   */
  function renderRelated(data, looseIndex) {
    var res = looseIndex == null ? null : data.results[looseIndex];
    if (!res || res.error || !res.hits || !res.hits.length) { elRelSec.innerHTML = ''; return; }
    var handles = res.hits
      .map(function (h) { return h.document.handle; })
      .filter(function (h) { return shown.indexOf(h) === -1; });
    if (!handles.length) { elRelSec.innerHTML = ''; return; }
    elRelSec.innerHTML = '<div class="nls-divider"><span class="nls-lbl">' +
      esc(t.related || 'Related products') + ' (' + handles.length + ')</span></div>' +
      '<div class="nls-grid" data-nls-relgrid style="margin-top:14px"></div>';
    renderCards(elRelSec.querySelector('[data-nls-relgrid]'), handles, '');
  }

  // ── Render ─────────────────────────────────────────────────────────────
  function render(data, facetIndex, looseIndex) {
    var p = data.results[0], c = data.results[1], m = data.results[2];
    var q = input.value.trim(), hasText = !!q;
    elClearQ.hidden = !hasText;

    var hits = [];
    if (p.grouped_hits) p.grouped_hits.forEach(function (g) { g.hits.forEach(function (h) { hits.push(h); }); });
    else hits = p.hits || [];
    found = p.found || 0;
    // Report the search. hasText only — the idle bestsellers screen is a
    // browse, not a query, and logging it would drown the report in blanks.
    if (hasText) AN.search(q, found, ACTIVE);

    var pageHandles = hits.map(function (h) { return h.document.handle; });
    // Load more appends; every other change replaced `shown` via reset().
    pageHandles.forEach(function (h) { if (shown.indexOf(h) === -1) shown.push(h); });

    // Idle with no filters is the bestsellers screen, never a "0 results"
    // screen — an empty catalogue there is a broken index, not a dead query.
    var isIdle = !hasText && !activeCount();
    var isEmpty = found === 0 && !isIdle;

    // Collections for the rail.
    var colHits = c.hits || [], colRows;
    if (!hasText && nav.length) {
      var byId = {}; colHits.forEach(function (h) { byId[h.document.id] = h.document; });
      colRows = nav.filter(function (n) { return byId[n.id]; }).map(function (n) {
        return { handle: byId[n.id].handle, title: n.title, count: byId[n.id].product_count };
      });
    } else {
      colRows = colHits.map(function (h) {
        return { handle: h.document.handle, title: T(h.document), count: h.document.product_count };
      });
    }
    if (hasText) {
      colRows = colRows.slice(0, MAX_COLLECTIONS);
    } else {
      // Biggest first, not menu order. The menu runs tops-then-bottoms, so
      // any cap taken in menu order shows nothing but tops — which is how a
      // 13-item list ended up reading as a shop that only sells shirts.
      // Ranking by size keeps the categories worth browsing at the top and
      // pulls Pants and Jeans up with them; the rest is one click away.
      colRows = colRows.slice().sort(function (a, b) { return (b.count || 0) - (a.count || 0); });
    }

    // Specific fabric stories that match the query — the escape hatch for the
    // long tail the family facet deliberately hides. Deduped: the `fabric`
    // metaobjects contain genuine duplicates.
    var seen = {}, matTerms = [];
    (m.hits || []).forEach(function (h) {
      var name = N(h.document), key = fold(name);
      if (!name || seen[key] || !h.document.product_count) return;
      seen[key] = 1; matTerms.push(name);
    });

    var railHtml = buildRail(data.results, facetIndex, colRows, matTerms, hasText, isEmpty);
    elRail.innerHTML = railHtml;
    elRail.classList.toggle('zero', isIdle);
    elInner.classList.toggle('norail', !railHtml);
    elSheetRail.innerHTML = buildRail(data.results, facetIndex, colRows, matTerms, hasText, isEmpty, true);
    renderChips();
    renderControls(hasText, isEmpty);
    if (elShowResults) elShowResults.textContent = fill(t.showResults || 'Show __N__ results', { '__N__': found });

    // Heading. One uppercase label: the count, and the query when there is one.
    if (isIdle) elTitle.textContent = t.bestsellers || 'Bestsellers';
    else if (isEmpty) elTitle.textContent = '';
    else if (hasText) elTitle.textContent = fill(t.resultsFor || '__N__ results for “__Q__”', { '__N__': found, '__Q__': q });
    // Filters but no query: there is no term to echo, so it is a bare count.
    else elTitle.textContent = resultsLabel(found);

    if (isEmpty) {
      elGrid.innerHTML = '';
      elFoot.innerHTML = '';
      elColSec.innerHTML = '';
      lastColId = null;
      renderRelated(data, looseIndex);
      // The nearest real destination: the best collection the QUERY matched.
      // When it matched none, renderNoResults shows best sellers with the
      // generic copy. It used to fall back to the biggest collection and call
      // that "the closest we make", so "blazer" and "suit" were sent to
      // Knitwear.
      var nearestRow = colRows[0] && COLS[colIdByHandle(colRows[0].handle)];
      renderNoResults(q, nearestRow || null);
      trackSearch(q, 0);
      return null;
    }
    elNoRes.innerHTML = '';
    renderCards(elGrid, shown, '');
    renderRelated(data, looseIndex);

    // "Showing N of M" + LOAD MORE, instead of a numbered pager. Not on the
    // idle screen: that query is grouped by style, so `found` counts styles
    // rather than products and a second page would double up colourways.
    if (isIdle) {
      elFoot.innerHTML = '';
    } else if (found > shown.length) {
      elFoot.innerHTML = '<span class="nls-num" style="letter-spacing:.04em">' +
        esc(fill(t.showingOf || 'Showing __A__ of __B__', { '__A__': shown.length, '__B__': found })) + '</span>' +
        '<button type="button" class="nls-btn" data-nls-more>' + esc(t.loadMore || 'Load more') + '</button>';
    } else if (shown.length > PER_PAGE) {
      elFoot.innerHTML = '<span class="nls-num" style="letter-spacing:.04em">' +
        esc(fill(t.showingOf || 'Showing __A__ of __B__', { '__A__': shown.length, '__B__': found })) + '</span>';
    } else {
      elFoot.innerHTML = '';
    }

    trackSearch(q, found);
    return hasText ? relatedCollection(hits) : null;
  }

  /**
   * The search key is now fetched, not published.
   *
   * The theme used to render Typesense's `search-only parent` key straight
   * into every page — permanent, unscoped, and the very secret the app uses
   * to mint scoped keys. `/api/search/key` hands back a key that is
   * search-only, pinned to one market, restricted to available products and
   * valid for an hour, and the parent stays on the server.
   *
   * Held in memory only: a key belongs to this tab and this hour, and
   * putting it in storage would just recreate a smaller version of the
   * problem being fixed.
   */
  var KEY_URL = String(cfg.keyUrl || '').replace(/\/+$/, '');

  /**
   * One statement of what "configured" means, announced at boot.
   *
   * The overlay only renders when `typesense_search_enabled` is on, and that
   * switch also takes the header's search button away from the native
   * predictive drawer. So a half-filled settings group is not a degraded
   * search, it is no search — and it used to say so only as a mixed-content
   * error against a localhost default nobody set.
   *
   * Reported here rather than on first query, because the whole point is to
   * be visible to whoever just flipped the switch, without waiting for a
   * shopper to find it. Naming the exact settings is the difference between
   * a two-minute fix and an afternoon.
   */
  var MISCONFIGURED = [];
  if (!host) MISCONFIGURED.push('typesense_host');
  if (!KEY_URL) MISCONFIGURED.push('typesense_key_url');
  if (MISCONFIGURED.length) {
    console.error(
      '[search] NOT CONFIGURED — Theme settings → Search (Typesense) is missing: ' +
      MISCONFIGURED.join(', ') + '. typesense_search_enabled is on, so the overlay has ' +
      'replaced the native predictive search, and every query will fail until these are set.'
    );
  }

  // The endpoint answers 400 for anything outside its supported sets, and a
  // shopper browsing from Belgium sends country BE. Clamping here keeps that
  // a non-event: every indexed product currently carries both markets, so a
  // clamped shopper sees exactly what they see today.
  var MARKET = (function (m) {
    m = String(m || '').toUpperCase();
    return m === 'NL' || m === 'DE' ? m : 'NL';
  })(cfg.market);
  var LOCALE = (function (l) {
    l = String(l || '').toLowerCase().slice(0, 2);
    return l === 'nl' || l === 'de' || l === 'en' ? l : 'en';
  })(cfg.locale);

  var keyState = { key: null, expires: 0, pending: null };

  function getKey() {
    if (!KEY_URL) return Promise.reject(new Error('no search key endpoint configured'));
    if (keyState.key && Date.now() < keyState.expires) return Promise.resolve(keyState.key);
    // One in-flight mint at a time: the overlay fires several searches on
    // open, and without this each would mint its own key.
    if (keyState.pending) return keyState.pending;
    var url = KEY_URL + (KEY_URL.indexOf('?') > -1 ? '&' : '?') +
      'market=' + encodeURIComponent(MARKET) + '&locale=' + encodeURIComponent(LOCALE);
    keyState.pending = fetch(url, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('search key request failed: ' + r.status);
        return r.json();
      })
      .then(function (j) {
        if (!j || !j.apiKey) throw new Error('search key response carried no key');
        keyState.key = j.apiKey;
        // Refreshed a minute early, so a search already in flight never
        // rides a key that expires under it.
        keyState.expires = Date.now() + Math.max(60, (Number(j.ttl) || 3600) - 60) * 1000;
        keyState.pending = null;
        return keyState.key;
      })
      .catch(function (e) { keyState.pending = null; throw e; });
    return keyState.pending;
  }

  /**
   * One Typesense request. Takes the same init object the old fetch calls
   * built, so the call sites keep their shape; only the header changes, and
   * it now comes from a key with a lifetime.
   */
  function tsFetch(init, isRetry) {
    return getKey().then(function (key) {
      init.headers = { 'Content-Type': 'application/json', 'X-TYPESENSE-API-KEY': key };
      return fetch(host + '/multi_search', init).then(function (res) {
        // A key can lapse mid-session (a tab left open past the hour, a
        // rotation on the cluster). Mint once more before giving up.
        if (res.status === 401 && !isRetry) {
          keyState.key = null;
          keyState.expires = 0;
          return tsFetch(init, true);
        }
        return res;
      });
    });
  }

  /**
   * Failure message, with a way out.
   *
   * The overlay intercepts the header search button in the capture phase
   * and handles Enter itself, so a shopper whose search fails has no route
   * to Shopify's own search short of typing the URL, and there is no second
   * search system on the store. This hands them the native search with
   * whatever they had already typed.
   */
  function unavailableHtml(msg, cls) {
    var q = (input && input.value ? input.value.trim() : '');
    var href = root + 'search?q=' + encodeURIComponent(q);
    var label = t.siteSearch || 'Search the site instead';
    return '<div class="' + cls + '">' + esc(msg) +
      ' <a class="nls-warn-link" href="' + esc(href) + '">' + esc(label) + '</a></div>';
  }

  function warn(msg) {
    elTitle.innerHTML = '';
    elGrid.innerHTML = '';
    elNoRes.innerHTML = unavailableHtml(msg, 'nls-warn');
  }

  // Without this the store would lose top-searches and, more importantly,
  // zero-result queries — the input that drives synonym and merchandising
  // work. Deduped so a debounced burst reports once.
  var lastTracked = null;
  function trackSearch(q, n) {
    if (!q || q === lastTracked) return;
    lastTracked = q;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'search', search_term: q, search_results: n });
    if (!n) window.dataLayer.push({ event: 'search_no_results', search_term: q });
  }

  function run(q) {
    if (MISCONFIGURED.length) {
      console.error(
        '[search] cannot search — missing ' + MISCONFIGURED.join(', ') +
        ' in Theme settings → Search (Typesense).'
      );
      // The shopper is not left at a dead end: `warn` carries a link through
      // to /search, which is the one route that works without any of this.
      warn(t.unavailable || 'Search is temporarily unavailable.');
      return;
    }
    var token = ++runToken;
    var req = body(q);
    // Skeletons only appear once handles are back (renderCards), which leaves
    // the Typesense round trip itself as a blank panel on first open. Fill it
    // — but ONLY when the grid is empty. Replacing live cards with skeletons
    // is exactly the image reload paint() exists to avoid, and it would make
    // every keystroke flicker.
    if (!elGrid.querySelector('[data-product-item]') &&
        !elGrid.querySelector('.nls-skel')) {
      elGrid.innerHTML = skeletons(FIRST_BATCH);
    }
    var release = busyLatch();
    tsFetch({ method: 'POST', body: JSON.stringify({ searches: req.searches }) })
      .then(function (r) { return r.json(); }).then(function (data) {
        release();
        if (token !== runToken) return;
        if (!data.results) throw new Error(JSON.stringify(data).slice(0, 300));
        appendCollection(render(data, req.facetIndex, req.looseIndex));
      }).catch(function (err) {
        release();
        if (token !== runToken) return;
        // Shoppers get one localised sentence; the detail belongs in the console.
        console.error('[search] Typesense request failed:', err);
        warn(t.unavailable || 'Search is temporarily unavailable.');
      });
  }

  // One-off lookups, memoised on the promise (not on a flag set after it
  // resolves — two fast opens used to issue two 250-document lookups):
  //
  //   1. every collection keyed by id, so "more from" and the no-results route
  //      can be scored against the result set. Counts still come per-query
  //      from the facets, so this never goes stale in a session.
  //   2. a probe for `material_family`.
  //   3. a probe for `rank_score`.
  //
  // The probes exist because Typesense fails the ENTIRE search when facet_by
  // or sort_by names a field the schema doesn't have — so a theme deployed
  // before the index carries material_family would lose Category, Colour,
  // Size and Sale too, not just Material, and one deployed before rank_score
  // exists would return nothing at all. Probing once and falling back keeps
  // the overlay fully working either way, and makes the deploy order a
  // convenience rather than a hard dependency.
  var lookupsPromise = null;
  function withLookups(cb) {
    if (lookupsPromise) return lookupsPromise.then(cb);
    lookupsPromise = tsFetch({ method: 'POST', body: JSON.stringify({ searches: [
      { collection: 'collections', q: '*', query_by: 'title_en', per_page: 250, sort_by: 'product_count:desc' },
      { collection: 'products', q: '*', query_by: 'title_en', facet_by: 'material_family', per_page: 0 },
      { collection: 'products', q: '*', query_by: 'title_en', sort_by: 'rank_score:desc', per_page: 0 }] }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        ((d.results[0] || {}).hits || []).forEach(function (h) {
          var cc = h.document;
          COLS[cc.id] = { id: cc.id, handle: cc.handle, title: T(cc), product_count: cc.product_count, is_material: !!cc.is_material };
        });
        if ((d.results[1] || {}).error) {
          console.warn('[search] no material_family in the index — Material filter hidden. ' +
            'Run the Typesense schema + reseed in nolabel-app (ts:cloud:schema, ts:cloud:seed:live).');
          GROUPS = GROUPS.filter(function (g) { return g.field !== 'material_family'; });
        }
        if ((d.results[2] || {}).error) {
          console.warn('[search] no rank_score in the index — ordering by sales alone, so new ' +
            'products stay buried. Add the field and reseed in nolabel-app ' +
            '(ts:cloud:field rank_score, ts:cloud:seed:live).');
          RANK_FIELD = 'sales_rank';
        }
      }).catch(function (err) { console.error('[search] lookups failed:', err); });
    return lookupsPromise.then(cb);
  }

  // Body scroll lock goes through picoapp's `body` component rather than
  // touching body.style directly. The overlay setting overflow itself left
  // isScrollLockEnabled out of sync, so the next drawer to open or close
  // silently no-opped.
  function lockScroll(enable) {
    if (window.app && window.app.emit) window.app.emit('body:toggleScrollLock', { enable: enable });
    else document.body.style.overflow = enable ? 'hidden' : '';
  }
  function isOpen() { return ov.classList.contains('open'); }
  function sheetOpen() { return sheet.classList.contains('open'); }
  function closeSort() {
    var pop = elCtrls.querySelector('[data-nls-sortpop]');
    if (!pop || !pop.classList.contains('open')) return false;
    pop.classList.remove('open');
    var trig = elCtrls.querySelector('[data-nls-sorttrig]');
    if (trig) trig.setAttribute('aria-expanded', 'false');
    return true;
  }
  function closeSheet() { sheet.classList.remove('open'); }

  // Back closes the takeover. Full screen on a phone, it reads as a page, and
  // Back used to leave the page underneath along with it. open() adds one
  // history entry (same URL, an `nls` flag on whatever state was there);
  // closing with × or Escape steps back off that entry, and popstate closes
  // the overlay on Back and reopens it on Forward.
  function ownsHistory() { return !!(history.state && history.state.nls); }
  function stateWithFlag(on) {
    var st = {}, cur = history.state;
    if (cur && typeof cur === 'object') for (var k in cur) st[k] = cur[k];
    if (on) st.nls = 1; else delete st.nls;
    return st;
  }
  // A reload (or a restore without bfcache) keeps the flag but not the open
  // overlay; left in place, the next close() would step back off the page.
  if (ownsHistory()) history.replaceState(stateWithFlag(false), '');
  window.addEventListener('popstate', function () {
    if (ownsHistory()) { if (!isOpen()) open(); }
    else if (isOpen()) close(true);
  });

  var lastFocus = null;
  // Set only while close() hands focus back, so the takeover below can tell a
  // restore from a shopper reaching for the search field.
  var restoringFocus = false;
  // `seed` carries over whatever was already typed into a field we are
  // taking over, so the takeover never costs the shopper their query.
  function open(seed) {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    ov.hidden = false;
    ov.classList.add('open');
    lockScroll(true);
    if (!ownsHistory()) history.pushState(stateWithFlag(true), '');
    if (seed) input.value = seed;
    input.focus();
    // The first open pays for the one-off lookups BEFORE run() is reached, so
    // without this the overlay opens onto a blank white panel for the length
    // of a 250-document round trip — the slowest moment in the whole flow and
    // the only one a shopper sees on every first search of a session.
    if (!elGrid.querySelector('[data-product-item]')) {
      elGrid.innerHTML = skeletons(FIRST_BATCH);
    }
    var release = busyLatch();
    withLookups(function () { reset(); run(input.value); }).then(release, release);
  }
  // `fromHistory`: popstate already moved off the overlay's entry.
  function close(fromHistory) {
    if (!isOpen()) return;
    closeSheet();
    ov.classList.remove('open');
    ov.hidden = true;
    lockScroll(false);
    if (fromHistory !== true && ownsHistory()) history.back();
    // Focus goes back where it came from, or the browser drops it on <body>
    // and keyboard users restart from the top of the document.
    //
    // Guarded, because the thing focus returns TO is usually the very
    // control that opens this overlay. .focus() dispatches focusin
    // synchronously, the capture-phase takeover below matched
    // [data-search-toggle], and open() sailed past its own isOpen() guard
    // because the class had already been removed one line earlier — so the
    // first press of Escape or the close button shut the overlay for a
    // single frame and reopened it, re-locking scroll and re-running the
    // whole Typesense round trip. Worst on the 404 template, where
    // data-search-toggle sits on an <input> that every browser focuses.
    var restore = lastFocus;
    lastFocus = null;
    if (restore && document.contains(restore)) {
      restoringFocus = true;
      restore.focus();
      restoringFocus = false;
    }
  }

  var devOpen = $('[data-nls-open]');
  if (devOpen) devOpen.addEventListener('click', open);

  // A focusin means "the shopper is reaching for search" only when they
  // tabbed into the field themselves. Every other way focus lands in one —
  // the browser restoring it on a back-navigation or a bfcache restore,
  // password-manager autofill, a page that loads with focus already there —
  // is not a request to search. On the 404 template, where
  // data-search-toggle sits on an <input> near the top of the document,
  // those paths opened a full-screen takeover over a page the shopper had
  // never chosen to leave, and the overlay's own failure state then read as
  // the 404 page itself being broken.
  var tabbedIn = false;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') tabbedIn = true;
  }, true);
  document.addEventListener('pointerdown', function () { tabbedIn = false; }, true);

  // Take over the header's search button AND the two search fields the old
  // system owns: the one inside the burger menu (mobile-menu.js) and the one
  // in the predictive-search drawer. Without the fields, tapping the icon
  // opened this overlay but typing in the menu ran a second, different search
  // underneath it.
  //
  // Capture phase + stopPropagation so header.js / mobile-menu.js never see
  // the event — no edits needed in either component, and flipping the setting
  // hands search straight back.
  if (cfg.takeover) {
    var takeover = function (e) {
      // close() is handing focus back to the control that opened us; the
      // focusin that causes must not reopen the overlay.
      if (restoringFocus) return;
      // Cleared on every focusin, so one Tab can only ever open the overlay once.
      if (e.type === 'focusin') {
        var viaTab = tabbedIn;
        tabbedIn = false;
        if (!viaTab) return;
      }
      var trig = e.target.closest &&
        e.target.closest('[data-search-toggle],[data-search-input]');
      if (!trig) return;
      e.preventDefault();
      e.stopPropagation();
      var seed = '';
      if (trig.hasAttribute('data-search-input')) {
        seed = trig.value || '';
        // preventDefault does not stop focus, and on a phone the keyboard
        // would otherwise attach to the field we are abandoning.
        trig.blur();
        // Close the menu BEFORE opening the overlay. Both take the body
        // scroll lock through picoapp's body component, so a menu left open
        // behind the overlay would release the lock when the overlay closes
        // and leave the page scrolling under an open menu.
        if (window.app && window.app.emit) {
          window.app.emit('mobileMenu:toggle', { mobileMenuOpen: false });
        }
      }
      open(seed);
    };
    document.addEventListener('click', takeover, true);
    // focusin as well as click: a tap fires both, but tabbing into the field
    // fires only focus, and a search box that does nothing for keyboard users
    // is worse than one that does the wrong thing. Gated on tabbedIn above so
    // only a real Tab counts. Safe against recursion — the overlay's own input
    // is [data-nls-input], not [data-search-input].
    document.addEventListener('focusin', takeover, true);
  }

  // The first search of a visit waits on the key, then the one-off lookups,
  // then the query, then the cards: 4.6s of a 6.7s first open on a slow line
  // went to the key alone. Start the key and the lookups as soon as the
  // shopper reaches for search (hover, touch or focus on a search control),
  // and open the Typesense connection alongside, instead of on the tap.
  var WARM_EVENTS = ['pointerover', 'touchstart', 'focusin'];
  function warm(e) {
    if (!(e.target.closest && e.target.closest('[data-search-toggle],[data-search-input]'))) return;
    WARM_EVENTS.forEach(function (type) { document.removeEventListener(type, warm, true); });
    if (MISCONFIGURED.length) return;
    var pre = document.createElement('link');
    pre.rel = 'preconnect';
    pre.href = host;
    pre.crossOrigin = 'anonymous';
    document.head.appendChild(pre);
    withLookups(function () {});
  }
  WARM_EVENTS.forEach(function (type) {
    document.addEventListener(type, warm, { capture: true, passive: true });
  });

  document.addEventListener('keydown', function (e) {
    // Only when the overlay is actually open. This listener is installed on
    // every page load, and it used to run close() — and therefore clear the
    // body scroll lock — for an Escape pressed at the cart drawer, the mobile
    // menu, the filter drawer or the size guide.
    if (!isOpen() || e.key !== 'Escape') return;
    if (sheetOpen()) { closeSheet(); return; }
    if (closeSort()) return;
    close();
  });

  // Keep Tab inside the dialog. Without this the page behind stays reachable
  // and a keyboard user tabs straight out of the overlay into the header.
  ov.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !isOpen() || sheetOpen()) return;
    var f = [].slice.call(ov.querySelectorAll(
      'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Enter used to navigate to the native /search page, which threw the shopper
  // out of the overlay and into a collection template with the PLP filter set
  // — strictly worse than the takeover they were already in. Enter now commits
  // the query in place: it cancels the pending debounce so the search runs at
  // once rather than 180ms later, and drops focus so mobile keyboards collapse
  // and reveal the grid.
  input.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    clearTimeout(debounce);
    reset();
    run(input.value);
    input.blur();
  });

  // Result clicks, delegated on the overlay so one listener covers the main
  // grid, the "more from this collection" grid and the related tier. Capture
  // phase: the card is a link, so the navigation that follows would otherwise
  // race the handler.
  ov.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-product-item]');
    if (!card || !card.dataset.productHandle) return;
    var handle = card.dataset.productHandle;
    AN.click(handle, card.dataset.productId || null, shown.indexOf(handle) + 1);
  }, true);

  var debounce;
  input.addEventListener('input', function () {
    clearTimeout(debounce);
    debounce = setTimeout(function () { reset(); run(input.value); }, 180);
  });
  elClearQ.addEventListener('click', function () {
    input.value = '';
    ACTIVE = {}; expanded = {};
    reset(); run('');
    input.focus();
  });

  // One delegated handler for the whole takeover AND the sheet: both render
  // the same rail markup, so the same data-* contract drives both.
  function onClick(e) {
    var expand = e.target.closest('[data-nls-expand]');
    if (expand) { expanded[expand.getAttribute('data-nls-expand')] = true; run(input.value); return; }

    var more = e.target.closest('[data-nls-more]');
    if (more) { page += 1; run(input.value); return; }

    var sortOpt = e.target.closest('[data-sort]');
    if (sortOpt) { sortId = sortOpt.getAttribute('data-sort'); closeSort(); reset(); run(input.value); return; }

    var sortTrig = e.target.closest('[data-nls-sorttrig]');
    if (sortTrig) {
      var pop = elCtrls.querySelector('[data-nls-sortpop]');
      var was = pop && pop.classList.contains('open');
      closeSort();
      if (pop && !was) { pop.classList.add('open'); sortTrig.setAttribute('aria-expanded', 'true'); }
      return;
    }

    if (e.target.closest('[data-nls-clear]')) { ACTIVE = {}; expanded = {}; reset(); run(input.value); return; }

    var opt = e.target.closest('[data-f]');
    if (opt) { toggle(opt.getAttribute('data-f'), opt.getAttribute('data-v')); reset(); run(input.value); return; }

    var term = e.target.closest('[data-term]');
    if (term) {
      input.value = term.getAttribute('data-term');
      ACTIVE = {}; expanded = {};
      closeSheet(); reset(); run(input.value); input.focus();
      return;
    }

    if (e.target.closest('[data-nls-sheetopen]')) { sheet.classList.add('open'); return; }
    if (e.target.closest('[data-nls-sheetclose]')) { closeSheet(); return; }
    if (e.target.closest('[data-nls-close]')) { close(); }
  }
  ov.addEventListener('click', onClick);
  sheet.addEventListener('click', onClick);

  // Sort popover closes on an outside click, like every other menu on the site.
  document.addEventListener('click', function (e) {
    if (!isOpen() || elCtrls.contains(e.target)) return;
    closeSort();
  });
})();
